import { Type } from "@sinclair/typebox";

export const ApiErrorSchema = Type.Object({
  code: Type.String(),
  message: Type.String(),
});
